import { useEffect, useState } from "react";
import { IconButton, Dialog, DialogTitle, DialogContent, Snackbar, Alert, Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import styles from "./myprofile.module.css";
import UpdateProfileForm from "../../components/UpdateProfileForm";
import ChangePasswordForm from "../user/ChangePasswordForm";
import Loader from "../../components/Loader";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Copy } from "react-feather";

const MyProfile = () => {
  const auth = authData();
  const [formOpenUpdateProfile, setFormOpenUpdateProfile] = useState(false);
  const [formOpenPassword, setFormOpenPassword] = useState(false);
  const userProfileData = localStorage.getItem("authData");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [customerLink, setCustomerLink] = useState("");

  useEffect(() => {
    if (authData()?.company?.urltoken) {
      setCustomerLink(process.env.REACT_APP_BASE_URL + '/customer-sign-up/' + authData()?.company?.urltoken);
    }
  }, []);

  return (<div className={`${styles.MainDiv}`}>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.PageTitleWrap}`}>
      <p className={`${styles.PageTitle}`}>My Profile</p>
    </div>
    <div className={`${styles.MainCard}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>{auth?.name}</p>
                <RouterLink className={`${styles.SideEditBU} `} onClick={(e) => setFormOpenUpdateProfile(true)}>Edit Profile</RouterLink>
                <RouterLink className={`${styles.SideEditBU} `} onClick={(e) => setFormOpenPassword(true)}>Change Password</RouterLink>
              </div>
              <div className={`${styles.UserProDe}`}>
                <p className={`${styles.UserProDeList}`}><span>Name:</span> {auth?.name}</p>
                <p className={`${styles.UserProDeList}`}><span>Email:</span> {auth?.email}</p>
                <p className={`${styles.UserProDeList}`}><span>Phone No:</span> {auth?.phone}</p>
                {auth?.company && <>
                  <p style={{ width: '100%', display: 'flex' }}>
                    <span style={{ width: '190px', fontSize: '14px', fontWeight: 500, color: '#7e8299', lineHeight: '22px' }}>Customer Registration Link:</span>
                    <CopyToClipboard text={customerLink}>
                      <Tooltip title={"Click to copy"}>
                        <span style={{ width: '400px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '15px', fontWeight: 600, lineHeight: '22px', color: '#ef233c', cursor: 'pointer' }}>{customerLink}</span>
                      </Tooltip>
                    </CopyToClipboard>
                    <CopyToClipboard text={customerLink}>
                      <Tooltip title={"Click to copy"}>
                        <Copy style={{ width: '18px', cursor: 'pointer' }} />
                      </Tooltip>
                    </CopyToClipboard>
                  </p>
                </>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog open={formOpenUpdateProfile} onClose={(e) => setFormOpenUpdateProfile(false)}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Update Profile</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpenUpdateProfile(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <UpdateProfileForm setFormOpenUpdateProfile={setFormOpenUpdateProfile.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} userProfileData={userProfileData} />
      </DialogContent>
    </Dialog>

    <Dialog open={formOpenPassword} onClose={(e) => setFormOpenPassword(false)}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Change Password</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpenPassword(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <ChangePasswordForm setFormOpen={setFormOpenPassword.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} id={auth?.id} />
      </DialogContent>
    </Dialog>

    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={(e) => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </div >);
};

export default withAdminAuth(MyProfile);